import { Typography } from "components/typography";
import { FeedbackDatePicker } from "components/icbt/assignIcbtModal/feedbackDate/feedbackDatePicker";
import { Divider } from "@mui/material";
import { styled } from "styled-components";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";
import { useAssignIcbt } from "../assignIcbtContext";
import { Icon } from "@mindlercare/ui-web";
import { useCallback, useState } from "react";

const FeedbackDateProgramItemContainer = styled.div<{ isSelected: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${({ theme }) => theme.PADDING.MD};
  align-items: center;
  width: auto;
  border-radius: 2px;
  background-color: ${({ theme, isSelected }) =>
    isSelected && theme.COLORS.LIGHT_ACTION_BLUE};
`;

const FeedbackDateItemInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const FeedbackDateItemActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.MARGIN.SM};
  align-self: end;
`;

const IconButtonContainer = styled(IconButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
`;

interface Props {
  programTitle?: string;
  treatmentTitle?: string;
  programId: string;
  programIndex?: number;
  onRemoveItem: () => void;
  onDateSelectorOpen: (arg: boolean) => void;
  patientUserId: string;
}

export const ProgramItemWithFeedbackDate = ({
  programTitle,
  treatmentTitle,
  programId,
  programIndex,
  onRemoveItem,
  onDateSelectorOpen,
  patientUserId,
}: Props) => {
  const { t } = useTranslation();
  const { state: assignIcbtState, dispatch } = useAssignIcbt();
  const { programFeedbackDates } = assignIcbtState.assignState;
  const handleSetFeedbackDate = (programId: string, date?: Date) => {
    dispatch({
      type: "setFeedbackDateForProgram",
      payload: { programId, date },
    });
  };

  const [isDateSelectorOpen, setIsDateSelectorOpen] = useState(false);

  const handleOpenDateSelector = useCallback(() => {
    setIsDateSelectorOpen(!isDateSelectorOpen);
    onDateSelectorOpen(!isDateSelectorOpen);
  }, [isDateSelectorOpen, onDateSelectorOpen]);
  return (
    <>
      <FeedbackDateProgramItemContainer isSelected={isDateSelectorOpen}>
        <FeedbackDateItemInnerContainer>
          <Typography insensitive variant="body" className="treatment-title">
            {programTitle}
          </Typography>
          <Typography
            variant="body-small"
            color="DARK_GREY"
            className="program-identifier"
            insensitive
          >
            {`${treatmentTitle} - ${t("PROGRAM")} ${programIndex}`}
          </Typography>
        </FeedbackDateItemInnerContainer>
        <FeedbackDateItemActionContainer>
          <FeedbackDatePicker
            value={
              programFeedbackDates ? programFeedbackDates[programId] : undefined
            }
            setValue={(date?: Date) => handleSetFeedbackDate(programId, date)}
            programId={programId}
            setIsSelected={handleOpenDateSelector}
            patientUserId={patientUserId}
          />
          <IconButtonContainer
            onClick={onRemoveItem}
            disabled={isDateSelectorOpen}
          >
            <Icon.Trash />
          </IconButtonContainer>
        </FeedbackDateItemActionContainer>
      </FeedbackDateProgramItemContainer>
      <Divider />
    </>
  );
};
